<template>
    <div class="info-paciente">
        <!-- <v-divider :thickness="3" class="border-opacity-50" color="#4CABD3">
            <h1 class="titulos">Información del paciente</h1>
        </v-divider> -->
        <div
            v-for="(item, index) in mostrarItemsPaciente"
            :key="index"
            style="
                display: grid;
                grid-template-columns: 1fr auto 1fr;
                align-items: center;
                text-align: center;
            ">
            <span style="text-align: right" class="indicador"
                >{{ item.indicador }}
            </span>
            <span style="padding: 0 5px" class="indicador">:</span>

            <span
                v-if="
                    (item.indicador === 'Peso' ||
                        item.indicador === 'Estatura') &&
                    activeInput === true
                "
                style="
                    text-align: left;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 30px;
                "
                class="valor">
                <v-text-field
                    v-model="item.valor"
                    class="peso-input valor"
                    density="compact"
                    outlined
                    variant="outlined"
                    hide-details
                    :counter="6"
                    :maxlength="6"
                    :min="0"
                    @input="
                        item.indicador === 'Peso'
                            ? onWeightInput(index, item.valor)
                            : ((item.valor = item.valor.replace(/\D+/g, '')),
                              onHeightInput(index, item.valor))
                    "
                    style="
                        max-width: 100px;
                        width: 80px;
                        margin-right: 5px;
                    "></v-text-field>
                {{ item.indicador === 'Peso' ? 'kg' : 'cm' }}
            </span>
            <span v-else style="text-align: left" class="valor">
                {{ item.valor }}
                <span
                    v-if="
                        (item.indicador === 'Peso' ||
                            item.indicador === 'Estatura') &&
                        item.valor
                    ">
                    {{ item.indicador === 'Peso' ? 'kg' : 'cm' }}
                </span>
            </span>
        </div>
    </div>
</template>
<script>
import { getPatientById } from '@/api/pacientes';
export default {
    props: {
        selectedPatientId: {
            type: String,
            default: '',
        },
        activeInput: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            mostrarItemsPaciente: [],
        };
    },
    created() {
        this.fetchPatientDetails();
    },
    methods: {
        fetchPatientDetails() {
            getPatientById(this.selectedPatientId)
                .then((patient) => {
                    this.mostrarItemsPaciente = [
                        { indicador: 'Nombre', valor: patient.nombre },
                        {
                            indicador: 'Primer apellido',
                            valor: patient.primerApellido ?? null,
                        },
                        {
                            indicador: 'Segundo apellido',
                            valor: patient.segundoApellido ?? null,
                        },
                        {
                            indicador: 'Fecha de nacimiento',
                            valor: patient.birthdate,
                        },
                        { indicador: 'Edad', valor: patient.edad },
                        { indicador: 'Sexo', valor: patient.sexo },
                        { indicador: 'Peso', valor: patient.peso },
                        { indicador: 'Estatura', valor: patient.estatura },
                    ];
                    const pesoItem = this.mostrarItemsPaciente.find(
                        (i) => i.indicador === 'Peso',
                    );
                    if (pesoItem) {
                        this.$emit('update-weight', { value: pesoItem.valor });
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        },
        onWeightInput(index, value) {
            const cleanValue = value.replace(/[^0-9.]/g, '').slice(0, 6);

            this.mostrarItemsPaciente[index].valor = cleanValue;

            this.$emit('update-weight', { value: cleanValue });
        },
        onHeightInput(index, value) {
            const cleanValue = value.replace(/[^0-9.]/g, '').slice(0, 6);

            this.mostrarItemsPaciente[index].valor = cleanValue;

            this.$emit('update-height', { value: cleanValue });
        },
    },
};
</script>

<style scoped>
.info-paciente {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 15px;
}
.indicador {
    color: var(--celeste-electrico);
    font-family: 'Trebuchet MS';
    font-weight: bold;
    font-size: 12pt;
}
.valor {
    font-family: 'Trebuchet MS';
    font-size: 12pt;
}

.peso-input :deep(.v-field__input) {
    padding-top: 2px !important;
    padding-bottom: 2px !important;
    min-height: 28px !important; /* más chico que el default */
}
</style>
